import React, { Component } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import MenuSlider from "../menu-slider/menu-slider";
import Auth from "../../utils/auth";
export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accessRights: Auth.get("access"),
    };
  }

  render() {
    document.onclick = function (e) {
      if (window.innerWidth <= 575) {
        var t = e.target;
        if (t.classList.contains("fa-bars")) {
          return false;
        }

        let bodyElements = document.getElementsByTagName("body");
        if (bodyElements && bodyElements[0]) {
          let body = bodyElements[0];
          if (body.classList.contains("sidebar-lg-show")) {
            body.classList.remove("sidebar-lg-show");
          }
        }
      }
    };
    return (
      <div className="app">
        <Header accessRights={this.state.accessRights} {...this.props} />
        <div className="app-body">
          <MenuSlider accessRights={this.state.accessRights} />
          <main className="main">{this.props.children}</main>
        </div>
        <Footer />
      </div>
    );
  }
}
